import React from 'react';
import {DatePicker, Form, InputNumber, message, Modal} from 'antd';
import moment from "moment";

class LeaseAmount extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      amount: 0,
      wef: '',
      id: '',
    };
  }

  onCancel = () => {
    this.props.showToggle(this.props.data._id);
  }

  // componentDidMount(){
  //   console.log(this.props);
  // }

  componentDidMount() {
    // console.log(this.props.amountCurrentRecord)
    const {data: currentData} = this.props;
    if(this.props.amountCurrentRecord) {
      const asset = currentData.assets.filter(item => item.id === this.props.assetRecord)
      if(asset && asset[0]) {
        const wefRecord = asset[0].leaseAmount.filter(item => item.id === this.props.amountCurrentRecord)
        if(wefRecord && wefRecord[0]) {
          console.log(wefRecord[0]);
          this.setState({
            wef: moment(wefRecord[0].wef),
            amount: wefRecord[0].amount,
            id: wefRecord[0].id,
          });

        }
      }
    } else {
      const periodFrom = currentData.assets[0].periodFrom || new Date();
      this.setState({
        wef: periodFrom,
        amount: 0,
        id: '',
      });
    }
  }

  onChange = (value, name) => {
    if(name === 'amount')
      this.setState({
        amount: parseFloat(value)
      });
    if(name === 'wef')
      this.setState({
        wef: value
      });
  };

  validate = () => {
    const {data: currentData} = this.props;
    const {wef} = this.state;
    const {leaseAmount, suspensionInfo} = currentData;
    const checkedAssets = leaseAmount.filter(item => item.wef === wef);
    if(checkedAssets && checkedAssets.length > 0) {
      message.error('Invalid WEF, already exist');
      return false;
    }
    return true;
  }

  onCreate = () => {
    const {amount, wef, id} = this.state;
    if(amount && wef) {
      this.props.updateAssets(this.props.contract, this.props.assetRecord, id ? 'update' : 'new', {
        leaseAmount: {
          id: id ? id : this.ObjectId(),
          wef: wef,
          amount: amount
        }
      });
      this.onCancel();
    }
  }

  ObjectId = (m = Math, d = Date, h = 16, s = s => m.floor(s).toString(h)) =>
    s(d.now() / 1000) + ' '.repeat(h).replace(/./g, () => s(m.random() * h));

  disabledDate = (current) => {
    const {data} = this.props;
    const assetData = data.assets.filter(doc => doc._id === this.props.assetRecord);
    if(assetData && assetData[0]) {
      const fromDate = assetData[0].periodFrom;
      const toDate = assetData[0].periodTo;
      return current && !moment(current).isBetween(moment(fromDate).startOf('day'), moment(toDate).endOf('day'));
    }
  }

  render() {
    const {visible, onCreate, form} = this.props;
    return (
      <div>
        <Modal
          visible={visible}
          title="Add new amount"
          okText="Save"
          onCancel={this.onCancel}
          onOk={this.onCreate}
        >
          <Form layout="vertical">
            <Form.Item key={`wef`} label={'WEF From'} style={{width: '100%'}}>
              <DatePicker defaultValue={moment(this.state.wef)} disabledDate={this.disabledDate}
                          onChange={(e) => this.onChange(e, 'wef')}/>
            </Form.Item>
            <Form.Item key={`amount`} label={'Amount'} style={{width: '100%'}}>
              <InputNumber defaultValue={this.state.amount} onChange={(e) => this.onChange(e, 'amount')}/>
            </Form.Item>

          </Form>
        </Modal>
      </div>
    );
  }
}

export default LeaseAmount;
